import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";
import { NestingRunView } from "shared";

export const runLayoutNesting = async (layoutId: string): Promise<NestingRunView> => {
  const response = await api.nesting.runLayoutNesting.mutation({ params: { id: layoutId } });

  if (response.status === 201) {
    return response.body;
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to run layout nesting", response.status, response.body);
};
